<style>

</style>

<template>
    <v-layout align-start>
        <v-flex>
            <v-data-table
            :headers="headers"
            :items="catUsuario"
            :search="search"
            class="elevation-1">
            <template v-slot:top>
                <v-toolbar flat color="white">
                <v-toolbar-title>Beneficios Pendientes</v-toolbar-title>
                <v-divider
                    class="mx-4"
                    inset
                    vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-text-field class="text-xs-center" 
                v-model="search" append-icon="search" 
                label="Busqueda" single-line hide-details>
                </v-text-field>
                <v-spacer></v-spacer>


            <!--/////////////*****/ DIALOG  -->
             <v-dialog v-model="dialog" fullscreen 
                        hide-overlay transition="dialog-bottom-transition">
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" 
                                dark v-on="on"
                                @click="bitacoraPrestaciones"
                                outlined>Bitacora de prestaciones</v-btn>
                        </template>
                        <v-card>
                            <v-toolbar dark color="primary">
                                <v-btn icon dark @click="dialog = false">
                                    <v-icon>close</v-icon>
                                </v-btn>
                                <v-toolbar-title><span class="headline">Prestaciones</span></v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>                        
                            <v-list three-line subheader>
                                <!-- <v-subheader><strong> Seleccione Tipo de grupo</strong></v-subheader> -->
                                <v-container fluid>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="12">
                                            <template>
                                                    <v-simple-table fixed-header>
                                                        <thead>
                                                        <tr>
                                                            <th class="text-left">IdPrestacion</th>
                                                            <th class="text-left">Prestacion</th>
                                                            <th class="text-left">Nombre</th>
                                                            <th class="text-left">NoEmpleado</th>
                                                            <th class="text-left">Documentos</th>
                                                            <th class="text-left">Estatus   |
                                                                   Aceptado 
                                                                   <v-icon small class="mr-2"  >
                                                                            done
                                                                   </v-icon> 
                                                                  | Rechazado 
                                                                   <v-icon small class="mr-2"  >
                                                                            close
                                                                   </v-icon> 
                                                                  | Pendiente 
                                                                   <v-icon small class="mr-2"  >
                                                                            timer
                                                                   </v-icon> 
                                                             </th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr
                                                            v-for="(item, index) in bitPrestacion"
                                                            :key="index"
                                                        >
                                                            <td>{{ item.idPrestacion }}</td> 
                                                            <td>{{ item.desPrestacion }}</td> 
                                                            <td>{{ item.nombre }}</td>
                                                            <td>{{ item.noEmpleado }}</td>
                                                            <td>
                                                                <div  v-for="(item3, index) in item.documento" :key="index">
                                                                  <template>

                                                                    <!-- <v-btn v-bind:href = "'https://localhost:44342/api/Beneficio/getFile?url=' + item3.urlFile" target="_blank"> -->
                                                                      <!-- <v-btn v-bind:href = "'http://api.cosmiccontigoweb.cosmic.mx/api/Beneficio/getFile?url=' + item3.urlFile" target="_blank">
                                                                   
                                                                        <v-icon small class="mr-2"  >
                                                                                 insert_drive_file
                                                                        </v-icon>
                                                                     </v-btn> -->
                                                                      <v-btn @click="displayFile(item3)">
                                                                        <!-- <v-icon small class="mr-2" @click="readFile(item)" > -->
                                                                        <v-icon small class="mr-2"  >
                                                                                 insert_drive_file
                                                                        </v-icon>
                                                                     </v-btn>
                                                                 </template>
                                                                </div>
                                                            </td>
                                                            <td>
                                                               <label  v-for="(item2, index) in item.vistoBuenoAreas" :key="index">
                                                                   {{item2.area}}

                                                                    <v-icon v-if="item2.vistoBueno == true" small class="mr-2"  >
                                                                            done
                                                                   </v-icon>
                                                                    <v-icon v-else-if="item2.vistoBueno == null" small class="mr-2"  >
                                                                          timer  
                                                                   </v-icon>
                                                                   <v-icon v-else small class="mr-2"  >
                                                                          close  
                                                                   </v-icon>
                                                               </label>
                                                               

                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </v-simple-table>
                                            </template>
                                        </v-col>
                                    </v-row>
                                      <v-pagination
                                        v-model="page"
                                        :length="length"
                                        :total-visible="5"
                                        @input="bitacoraPrestaciones"
                                        ></v-pagination>
                                </v-container>
                            </v-list>
                        </v-card>
                        <v-divider></v-divider>
                    </v-dialog>
            <!--/////////////*****/END DIALOG  -->
                </v-toolbar>

                
                
                <v-dialog v-model="dialogconfirm" max-width="290">
                    <v-card>
                        <v-card-title class="headline">Confirmar</v-card-title>
                        <v-card-text>
                           Esta a punto de confirmar el beneficio para el colaborador, ¿Desea continuar?.
                        </v-card-text>

                        <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="green darken-1"
                            text
                             @click="dialogconfirm = false"
                        >
                            Cerrar
                        </v-btn>
                        <v-btn
                            color="green darken-1"
                            text
                            @click="confirmar(false)"
                        >
                            Rechazar
                        </v-btn>

                        <v-btn
                            color="green darken-1"
                            text
                            @click="confirmar(true)"
                        >
                            Aceptar
                        </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

              <v-dialog v-model="dialogFile" fullscreen>
                    <v-card>
                        <v-toolbar dark color="primary">
                                <v-btn icon dark @click="dialogFile = false">
                                    <v-icon>close</v-icon>
                                </v-btn>
                                <v-toolbar-title><span class="headline">Documentos</span></v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar> 

                            <v-list three-line subheader>
                                <!-- <v-subheader><strong> Seleccione Tipo de grupo</strong></v-subheader> -->
                                <v-container fluid>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="12">
                                            <template>
                                                    <v-simple-table fixed-header>
                                                        <thead>
                                                        <tr>
                                                            <th class="text-left">Nombre</th>
                                                            <th class="text-left">Archivo</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr
                                                            v-for="(item, index) in urlfile"
                                                            :key="index"
                                                        >
                                                            <td>{{ item.nombreArchivo }}</td> 
                                                            <td>
                                                                    <!-- <v-btn v-bind:href = "'https://localhost:44342/api/Beneficio/getFile?url=' + item.urlFile" target="_blank"> 
                                                                        <v-btn v-bind:href = "'http://api.cosmiccontigoweb.cosmic.mx/api/Beneficio/getFile?url=' + item.urlFile" target="_blank">
                                                                        <v-icon small class="mr-2" @click="readFile(item)" > -->
                                                                        <!-- <v-icon small class="mr-2"  >
                                                                                 insert_drive_file
                                                                        </v-icon> --> 



                                                                        <v-btn @click="displayFile(item)">
                                                                        <!-- <v-icon small class="mr-2" @click="readFile(item)" > -->
                                                                        <v-icon small class="mr-2"  >
                                                                                 insert_drive_file
                                                                        </v-icon>
                                                                    </v-btn>
                                                            </td> 
                                                            
                                                        </tr>
                                                        </tbody>
                                                    </v-simple-table>
                                            </template>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-list>
                        </v-card> 
                </v-dialog>

                <!-- <v-dialog v-model="dialogDisplayFile" fullscreen  hide-overlay transition="dialog-bottom-transition">
                 <v-card>
                   <v-toolbar dark color="primary">
                                <v-btn icon dark @click="dialogDisplayFile = false">
                                    <v-icon>close</v-icon>
                                </v-btn>
                                <v-toolbar-title><span class="headline">Archivo</span></v-toolbar-title>
                                <v-spacer></v-spacer>
                    </v-toolbar> 
                    <div >
                                 <iframe :src="pathDisplay" style="width:100%;height:700px;">
                                </iframe> -->
                    <!-- </div>                    
                </v-card>  -->
                    <!-- <v-card>
                             <v-toolbar dark color="primary">"
                                <v-btn icon dark @click="dialogDisplayFile = false">
                                    <v-icon>close</v-icon>
                                </v-btn>
                                <v-toolbar-title><span class="headline">Archivo</span></v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar> 
                               <div>
                                    <img :src="pathDisplay" style="-webkit-user-select: none;margin: auto;cursor: zoom-in;" frameborder="0" allowfullscreen width="436" height="582"/>
                                    <iframe style="-webkit-user-select: none;margin: auto;cursor: zoom-in;" :src="pathDisplay" frameborder="0" allowfullscreen width="436" height="582"> 
                                      
                                    </iframe>
                               </div>
                           
                        </v-card>  -->
                <!-- </v-dialog> -->


            </template> 
            <template v-slot:body="{ items }">
                <tbody>
                    <tr v-for="(item, index) in items" :key="index">
                         
                         <td>
                           <div>
                                 <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                       <v-icon small class="mr-2" @click="openconfirm(item)">
                                            pan_tool 
                                      </v-icon>
                                    </v-btn>
                                    </template>
                                    <span>Dar Vobo</span>
                                </v-tooltip>
                                 <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                  <!-- <v-btn icon v-on="on" v-bind:href="'https://localhost:44342/api/Beneficio/getFile?url=' + item.urlFoto"> -->
                                   <!-- <v-btn icon v-on="on" v-bind:href="'http://api.cosmiccontigoweb.cosmic.mx/api/Beneficio/getFile?url=' + item.urlFoto"> -->
                                       <!-- <v-icon small class="mr-2" @click="readFile(item)" > -->

                                   <v-btn icon v-on="on">
                                       <v-icon small class="mr-2" @click="openFile(item.idPrestacion)">
                                            insert_drive_file
                                      </v-icon>
                                    </v-btn>
                                   <!-- <v-icon small class="mr-2"  >
                                            insert_drive_file
                                      </v-icon>
                                    </v-btn> -->
                                    </template>
                                    <span>Documentos</span>
                                </v-tooltip>
                            </div>
                        </td>
                        <td>{{ item.idPrestacion }}</td>
                        <td>{{ item.desPrestacion }}</td>
                        <td>{{ item.nombre }}</td>
                        <td>{{ item.fechaAlta }}</td>
                        <td>{{ item.noEmpleado }}</td>
                    </tr>
                </tbody>
            </template>
            </v-data-table>
        </v-flex>
    </v-layout>
</template>  

<script>
import axios from 'axios'
import moment from 'moment'

export default {
   created () {
        this.listar()
    },
    data() {
        return {   
            catUsuario:[],
            bitPrestacion:[],
            TituloNombre:'',
            catUsuarioSuperior:[],
            length: 0,
            pathDisplay:"",
            beneficiario:{
                IdPrestacion:'',
                Descripcion:'',
                UrlFoto:'',
                URLDocumento:'',
                IdUsuario:'',
                Nombre:'',
                NoEmpleado:'',
                IdUsuarioCosmic:'',
                IdCatEstatus:'',
                VistoBueno:''
            },
            image:{
                size:'',
                height:'',
                 width:''
                 },
             imageLoaded:false,
            selectUser: {},
            selectSup: [],
            dialogconfirm: false,
            dialogFile: false,
            dialogDisplayFile: false,
            dialog: false,
            page:1,
            consultaDto: {
                Skip: 0,
                Take: 10,
                descending: true,
                sortBy: '',
                search: '',
                idUsuario: 4,
                extraParam: ''
            },
            urlfile:[],
            headers: [
                { text: 'Opciones', value: 'opciones', sortable: false },
                { text: 'IdPrestacion', value: 'idPrestacion', sortable: false },
                { text: 'Descripcion', value: 'desPrestacion', sortable: false },
                { text: 'Nombre', value: 'nombre', sortable: false },
                { text: 'Fecha', value: 'fechaAlta' },
                { text: 'NoEmpleado', value: 'noEmpleado' },
             
            ],
            search: '',
            snackbar: false,
            snackbarcolor: '',
        }
    },
    watch: {
      
    },
    
    methods: {
        listar(){
           let me = this
           debugger
            me.$store.dispatch('setIsBusy', true)

            me.consultaDto.idUsuario = me.$store.state.sUsuario.usuario.idUsuario;
         
          
            me.$axios.post('api/Beneficio/Get', me.consultaDto)
                .then(r => {
                    if (r.data.exito) {
                        me.catUsuario = r.data.data
                        me.$root.Mensaje(r.data.mensaje)
                    }
                    else
                    {
                        me.$root.Mensaje(r.data.mensaje)
                    }
                  
                    me.$store.dispatch('setIsBusy', false)
                })
                .catch(e => { 
                     me.$store.dispatch('setIsBusy', false)
                    console.log(e) }
                    )
        },
        forceFileDownload(response){
                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'file.jpg') //or any other extension
                    document.body.appendChild(link)
                    link.click()
         },
        openconfirm(item) {
            this.dialogconfirm = true
            this.beneficiario.IdPrestacion = item.idPrestacion,
            this.beneficiario.IdCatArea = item.idCatArea,
            this.beneficiario.VistoBueno = item.vistoBueno
         },
         confirmar(estatus) {
            debugger
            let ctx = this;
           
             var json = { 
                    "VistoBueno" : estatus,
                    "IdPrestacion" : ctx.beneficiario.IdPrestacion,
                    "IdCatArea" : ctx.beneficiario.IdCatArea 
                }; 
                debugger;
                axios.post('api/Beneficio/confirmar', json )
                .then(function(response){
                        // ctx.listar();
                        ctx.snackbar = true;
                        ctx.snackbarcolor = 'teal darken-4';
                        ctx.listar();
                    }).catch(function(error){
                    console.log(console.error());
                });
             this.dialogconfirm = false
         },
         bitacoraPrestaciones()
         {
           let me = this
           debugger
            me.$store.dispatch('setIsBusy', true)
            me.consultaDto.extraParam = me.page.toString()
            me.$axios.post('api/Beneficio/GetBitacora', me.consultaDto)
                .then(r => {
                    if (r.data.exito) {
                        me.bitPrestacion = r.data.data
                        me.length = r.data.integer
                        me.$root.Mensaje(r.data.mensaje)
                    }
                    else
                    {
                         me.$root.Mensaje(r.data.mensaje)
                    }
                   
                    me.$store.dispatch('setIsBusy', false)
                })
                .catch(e => { console.log(e) })
         },
         openFile(idPrestacion)
         {
           let me = this
           debugger
               me.$axios.get('api/Beneficio/GetUrlFile?idPrestacion=' + idPrestacion + "&idPlatform=1")
                .then(r => {
                    if (r.data.exito) {
                        me.urlfile = r.data.data
                    }
                })
                .catch(e => { console.log(e) })
              this.dialogFile = true
         },
         displayFile(item)
         {
            debugger
            let me = this
            
            var cadena = item.urlFile
            // var u1 = 'http://apicontigo.cosmic.mx/Documentos'
            // if (cadena === undefined || cadena === '' || cadena === null)
            //     return ''
            var a = cadena.replace("C:\\Inetpub\\vhosts\\cosmic.mx\\apicontigo.cosmic.mx\\", "http://apicontigo.cosmic.mx/")

            var r = a.replace("\\","/")
            // var arr = cadena.split('FileMessage')
            // if (arr.length > 0) {
            //     url = u1 + arr[1]
            // }

           
            // this.dialogDisplayFile = true
            // me.pathDisplay = r
            // window.location.href = r 
             window.open(r, '_blank');
      }
            // document.getElementById("img").height= 100%
         
    },
}
</script>